import type { FileMessage as FileMessageType } from 'app/types/chat';
import { getLocalCacheForImage, PCImage } from 'app/design/primitives/image';
import { useState } from 'react';
import { Pressable } from 'react-native';
import ImageViewerModal from 'app/design/primitives/image-viewer-modal';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface FileMessageProps {
  message: FileMessageType;
  onLongPress?: () => void;
}

function FileMessage({ message, onLongPress }: FileMessageProps) {
  const [isImageViewerModalOpen, setIsImageViewerModalOpen] = useState(false);
  return (
    <>
      <Pressable delayLongPress={300} onLongPress={onLongPress} onPress={() => setIsImageViewerModalOpen(true)}>
        <PCImage
          aspectRatio={1}
          contentFit="cover"
          source={{ uri: message.file.url }}
          style={{
            borderColor: theme.colors['border.secondary'],
            borderRadius: theme.borderRadii['radius.sm'],
            borderWidth: theme.borderWidths['border-width.subtle'],
          }}
          useOwnCache
        />
      </Pressable>
      <ImageViewerModal
        imageUrls={[{ url: getLocalCacheForImage(message.file.url) ?? message.file.url }]}
        onClose={() => setIsImageViewerModalOpen(false)}
        open={isImageViewerModalOpen}
      />
    </>
  );
}

export { FileMessage };
